<template>
    <kgr-profile-part
        v-if="!isEmpty"
        :heading="$t('memberShortProfile.memberHonors')"
    >
        <template #content>
            <table class="kgr-table">
                <tr
                    v-for="honor in filteredHonors"
                    :key="honor.value + honor.date"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        {{ moment(honor.date).format('DD.MM.YYYY') }}
                    </td>
                    <td class="kgr-table__cell">
                        <div>
                            {{ honor.value }}
                        </div>
                    </td>
                </tr>
            </table>
            <div v-if="hasMore">
                <a
                    class="kgr-text kgr-text--extraSmall kgr-float kgr-float--right custom-action kgr-link"
                    @click="showAll = !showAll"
                >
                    <kgr-icon
                        :icon-class="`arrow-${showAll ? 'up' : 'down'}`"
                        hover-accent
                    />
                    <span
                        v-t="showAll ? 'memberShortProfile.memberHonors.less' : 'memberShortProfile.memberHonors.more'"
                    ></span>
                </a>
            </div>
        </template>
    </kgr-profile-part>
</template>

<script>
import Icon from '../../common/icon/Icon.vue';
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    components: {
        'kgr-profile-part': ProfilePart,
        'kgr-icon': Icon,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    data() {
        return {
            showAll: false,
            limit: 3,
        };
    },
    computed: {
        isEmpty() {
            return !this.memberShortProfile.memberHonors || this.memberShortProfile.memberHonors.length === 0;
        },
        hasMore() {
            return this.memberShortProfile.memberHonors && this.memberShortProfile.memberHonors.length > this.limit;
        },
        filteredHonors() {
            if (this.showAll) {
                return this.memberShortProfile.memberHonors;
            }
            return this.memberShortProfile.memberHonors.slice(0, this.limit);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.custom-action {
    cursor: pointer;
    text-decoration: none;
}
.custom-action span {
    vertical-align: super;
}
</style>
